import { render, staticRenderFns } from "./smptype.vue?vue&type=template&id=981ab6a6&scoped=true&"
import script from "./smptype.vue?vue&type=script&lang=js&"
export * from "./smptype.vue?vue&type=script&lang=js&"
import style0 from "./smptype.vue?vue&type=style&index=0&id=981ab6a6&scoped=true&lang=less&"
import style1 from "./smptype.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ab6a6",
  null
  
)

export default component.exports